var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("div", {
    staticClass: "card-container"
  }, _vm._l(_vm.insuranceInfoList, function (item) {
    return _c("div", {
      key: item.id,
      staticClass: "insurance-item",
      on: {
        click: function ($event) {
          return _vm.toDetail(item);
        }
      }
    }, [_c("div", {
      staticClass: "img-container"
    }, [item.coverUrl ? _c("img", {
      staticClass: "img-cover",
      attrs: {
        slot: "cover",
        alt: "",
        src: item.coverUrl
      },
      slot: "cover"
    }) : _c("img", {
      staticClass: "img-cover",
      attrs: {
        slot: "cover",
        src: require("@/assets/noImage.png")
      },
      slot: "cover"
    })]), _c("div", {
      staticClass: "title"
    }, [_vm._v(_vm._s(item.name))])]);
  }), 0), _c("div", {
    staticStyle: {
      "margin-top": "20px",
      "text-align": "right"
    }
  }, [_vm.insuranceInfoList.length !== 0 ? _c("a-pagination", {
    attrs: {
      pageSize: _vm.pagination.pageSize,
      total: _vm.pagination.total,
      "show-size-changer": "",
      "show-quick-jumper": "",
      "show-less-items": "",
      "show-total": total => _vm.$t("共") + total + _vm.$t("条")
    },
    on: {
      change: _vm.onPageChange,
      showSizeChange: _vm.onShowSizeChange
    },
    model: {
      value: _vm.pagination.current,
      callback: function ($$v) {
        _vm.$set(_vm.pagination, "current", $$v);
      },
      expression: "pagination.current"
    }
  }) : _vm._e()], 1)]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };